// const STORAGE_KEY = "information-banner-dismissed";

export function InformationBanner() {
  // reactiver si on enleve sq
  return null;

  // const [isDismissed, setIsDismissed] = useState(true);

  // useEffect(() => {
  //   const dismissed = localStorage.getItem(STORAGE_KEY);
  //   setIsDismissed(dismissed === "true");
  // }, []);

  // const handleClose = () => {
  //   localStorage.setItem(STORAGE_KEY, "true");
  //   setIsDismissed(true);
  // };

  // return (
  //   <AnimatePresence>
  //     {!isDismissed && (
  //       <motion.div
  //         initial={{ y: 32, opacity: 0 }}
  //         animate={{
  //           y: 0,
  //           opacity: 1,
  //           transition: { delay: 2, type: "spring" },
  //         }}
  //         exit={{ y: 32, opacity: 0 }}
  //         className="fixed bottom-4 left-0 right-0 bg-card rounded-full w-3xl border-warning mx-auto shadow border z-100"
  //       >
  //         <div className="flex gap-2 p-1 items-center">
  //           <div className="text-muted-foreground text-sm bg-warning py-1 px-2 text-warning-foreground rounded-full flex items-center justify-center">
  //             <span>Attention</span>
  //           </div>
  //           <span className="line-clamp-1 flex-1">
  //             Colissimo est victime d'une attaque. Des dysfonctionnements sont à
  //             prévoir.{" "}
  //           </span>
  //           <a
  //             target="_blank"
  //             href="https://www.laposte.fr/colissimo"
  //             className="text-xs underline inline-flex gap-1 items-center"
  //           >
  //             Voir plus <ExternalLink className="size-3" />
  //           </a>
  //           <button
  //             type="button"
  //             onClick={handleClose}
  //             className="flex items-center justify-center pr-2 cursor-pointer"
  //           >
  //             <XIcon className="size-4 text-muted-foreground" />
  //           </button>
  //         </div>
  //       </motion.div>
  //     )}
  //   </AnimatePresence>
  // );
}
